
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.005","height":"19.005","viewBox":"0 0 19.005 19.005"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","data-name":"vuesax/twotone/discount-shape"}},[_c('path',{attrs:{"d":"M3.16 11.609l-1.204-1.205a1.271 1.271 0 010-1.79l1.2-1.2a1.461 1.461 0 00.372-.895v-1.7a1.271 1.271 0 011.271-1.271h1.7a1.461 1.461 0 00.895-.372l1.2-1.2a1.271 1.271 0 011.79 0l1.2 1.2a1.461 1.461 0 00.895.372h1.7a1.271 1.271 0 011.279 1.267v1.7a1.461 1.461 0 00.372.895l1.2 1.2a1.271 1.271 0 010 1.79l-1.2 1.2a1.461 1.461 0 00-.372.895v1.7a1.271 1.271 0 01-1.27 1.279h-1.7a1.461 1.461 0 00-.895.372l-1.2 1.2a1.271 1.271 0 01-1.79 0l-1.2-1.2a1.461 1.461 0 00-.895-.372h-1.7a1.271 1.271 0 01-1.276-1.27v-1.7a1.424 1.424 0 00-.372-.895z","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M7.127 11.878l4.751-4.751","stroke-width":"1.5","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.478 11.482h.005M7.519 7.523h.005","stroke-width":"2","opacity":".4"}})])])
          )
        }
      }
    